import React, { Component } from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Switch } from 'react-router-dom'

import AuthRouter from './AuthRouter'

import { updateSettings, isConfigured } from '../actions/settings'

class MainRouter extends Component {

    componentDidMount() {
        const { dispatch } = this.props
        dispatch(updateSettings(window.LOCAL_SETTINGS))
    }

    render() {
        return (
            <div>
              <Switch>
                <AuthRouter />
              </Switch>
            </div>
        )
    }
}
function mapStateToProps(state) {
    
    const is_configured = isConfigured(state)
    return {
        is_configured
    }
}
export default withRouter(connect(mapStateToProps)(MainRouter))
